interface ISettingContentWrapperProps {
  children: React.ReactNode | string
  fluid?: boolean
  className?: string
}

const SettingContentWrapper: React.FC<ISettingContentWrapperProps> = ({ children, fluid = true, className = "" }) => {
  const width = fluid ? `lg:w-full` : `sm:!w-3/5 md:w-3/5 lg:w-full`
  return (
    <div className={`flex flex-col bg-white rounded-lg p-6 w-full mt-5 mb-5 shadow-kosmo ${width} ${className}`}>
      {children}
    </div>
  )
}

export default SettingContentWrapper
